<template>
	<div class="d-flex flex-1 h-100 overflow-auto">
		<v-card class="report-container w-100 p-3" style="border-radius: 12px; margin-bottom: 24px">
			<v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
				<div class="custom-icon-wrapper">
					<v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
				</div>
				<v-toolbar-title class="size-16 dark-text">{{$t('res_Label_ManageRoles')}}</v-toolbar-title>
			</v-toolbar>
			<div>
				<v-card-title>
					<div class="border-top flex-1 overflow-auto text-end" style="padding-top: 13px;">
						<v-btn @click="showAddDialog" width="200px" color="primary">{{$t('res_Label_AddNewRole')}}</v-btn>
					</div>
				</v-card-title>
			</div>
			<div class="d-flex flex-1 flex-column overflow-auto" style="padding: 5px; padding-top: 0px;">
				<v-data-table :headers="headers" :items="roles" :items-per-page="-1"  disable-sort hide-default-footer class="position-relative white flex-1 d-flex overflow-auto">
					<template v-slot:item="row">
						<tr>
							<td>{{ row.item.id }}</td>
							<td>{{ row.item.name }}</td>
							<td>{{ row.item.description }}</td>
							<td>{{ row.item.createdDate.slice(0,10) }}</td>
							<td>{{ row.item.modifiedDate == null? row.item.modifiedDate : row.item.modifiedDate.slice(0,10) }}</td>
							<td>{{ row.item.application }}</td>
							<td>{{ row.item.color }}</td>
							<td class="text-start">
								<div class="onhover-display">
									<div class="custom-icon-wrapper">
										<v-icon v-tooltip="$t('res_MenuItem_Edit')" small @click="editItem(row.item)">custom-icon white-bg edit-icon</v-icon>
									</div>
									<div class="custom-icon-wrapper">
										<v-icon v-tooltip="$t('res_Label_ManageRoles')" small @click="manageRoleHandler(row.item.id, row.item.applicationId)">custom-icon white-bg settings-outline-icon gear-icon</v-icon>
									</div>
									<div class="custom-icon-wrapper">
										<v-icon v-tooltip="$t('res_MenuItem_Delete')" small @click="openDeleteDialog(row.item)">custom-icon white-bg
											delete-icon</v-icon>
									</div>
								</div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-card>
		<v-dialog v-model="manageSecurityDialog" max-width="1000px" min-height="1000px">
			<v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        <span>{{$t('res_Label_ManagePermissions')}}</span>
					</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="closemanageSecurityDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                   <div class="grid-12 flex-1 p-4 overflow-auto gap-2">
						<ActionSecurityRole :roleId="editedRoleId" :search="Search" :seacrhvalue="SearchValue" :applicationId="applicationId" />
					</div>
				</div>
			</v-card>
		</v-dialog>
		<v-dialog v-model="addDialogVisible" max-width="500px">
			<v-card>
				<v-toolbar class="bg-white">
					<v-card-title class="p-0">
						<span v-if="editedItem.id">{{$t('res_Label_EditRole')}}</span>
						<span v-else>{{$t('res_Label_AddRole')}}</span></v-card-title>
					<v-spacer></v-spacer>
					<v-btn class="close-btn light-btn" icon dark @click="addDialogVisible = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
				<div class="d-flex flex-column overflow-auto h-100">
					<div class="grid-12 flex-1 p-4 overflow-auto gap-2">
						<v-row>
							<v-col cols="6">
								<v-label>{{$t('res_Label_Name')}} *</v-label>
								<v-text-field solo v-model="editedItem.name"></v-text-field>
							</v-col>
							<v-col cols="6" sm="6">
								<v-label>{{$t('res_Label_Description')}} *</v-label>
								<v-text-field solo v-model="editedItem.description"></v-text-field>
							</v-col>
							<v-col cols="6" sm="6">
								<v-label>{{$t('res_GridHeader_Application')}} *</v-label>
								<v-select v-model="editedItem.applicationId" :items="applicationsOptions" solo
									item-text="text" item-value="value">
								</v-select>
							</v-col>
							<v-col cols="6" sm="6">
								<v-label>{{$t('res_GridHeader_ColorIcon')}}</v-label>
								<v-text-field solo v-model="editedItem.color"></v-text-field>
							</v-col>

						</v-row>
					</div>
					<v-card-actions class="gap-2 sticky-actions">
						<v-spacer></v-spacer>
						<v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelAddDialog()">{{
							$t("res_ButtonText_Cancel") }}</v-btn>
						<v-btn class="primary" style="min-width: 100px !important;" @click="upsertItem(editedItem)">{{
							$t("res_ButtonText_Continue") }}</v-btn>
					</v-card-actions>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";
import constants from "@/assets/js/constants.js";
import ActionSecurityRole from '@/components/ActionSecurityRole.vue'
import router from '@/router/index.js'

export default {
	components: {ActionSecurityRole},
	mounted() 
	{
		this.getRoles();
		var applicationsOptionsToShow = []
		window.availableApplications.forEach(item =>
		{
			if (item == 1)
				applicationsOptionsToShow.push(this.applicationsOptions[0]);
			else if (item == 2)
				applicationsOptionsToShow.push(this.applicationsOptions[1]);
			else if (item == 3)
				applicationsOptionsToShow.push(this.applicationsOptions[2]);
		});
		this.applicationsOptions = applicationsOptionsToShow
	},
	data() {
		return {
			headers: [
				{ text: 'Id', width: "3%" },
				{ text: this.$t('res_GridHeader_RoleName'), width: "13%" },
				{ text: this.$t('res_Label_Description'), width: "20%" },
				{ text: this.$t('res_Label_CreatedDate'), width: "11%" },
				{ text: this.$t('res_GridHeader_ModifiedDate'), width: "12%" },
				{ text: this.$t('res_GridHeader_Application'), width: "12%" },
				{ text: this.$t('res_GridHeader_ColorIcon'), width: "10%" },
				{ text: this.$t('res_GridHeaders_Actions'), value: "actions", align: "start", width: "13%" },
			],
			roles: [],
			applicationsOptions: [
				{ text: 'CTS', value: 1 },
				{ text: 'TMS', value: 2 },
				{ text: 'MMS', value: 3 }
			],
			addDialogVisible: false,
			editedItem: {
				id: 0,
				name: "",
				description: null,
				applicationId: 0,
				color: ''
			},
			manageSecurityDialog: false,
			editedRoleId: undefined,
			applicationId: 0,
			Search:"",
			SearchValue:"",
		};
	},
	methods: {
		backToAdminPage()
		{
            router.push({ name: 'admin' })
        },
		async getRoles() 
		{
			window.showLoading();
			axios.get(constants.baseApiUrl + 'ActionSecurity/GetRoles')
				 .then((res)=>{this.roles = res.data})
				 .catch((err) => console.log(err))
				 .finally(()=>{
					window.hideLoading();
					this.roles.forEach(role => {
						const app = this.applicationsOptions.find(app => app.value === role.applicationId);
						if (app) {role.application = app.text;}
					})
				})
		},
		manageRoleHandler(roleId, applicationId) {
			this.manageSecurityDialog = true;
			this.editedRoleId = roleId;
			this.applicationId = applicationId
		},
		showAddDialog() {
			this.addDialogVisible = true
			this.editedItem = { id: 0, name: "", description: "", applicationId: 0,color: "" }
		},
		editItem(item) {
			this.editedItem = { ...item };
			this.addDialogVisible = true;
		},
		async upsertItem(item) {
			if (this.editedItem.name.trim() == "" || this.editedItem.description.trim() == "" || this.editedItem.applicationId == 0) {
				window.showAlert('res_Msgs_FillRequired', 'warning')
				return;
			}
			if (this.editedItem.id == 0) {
				var role = { id: 0, name: this.editedItem.name, description: this.editedItem.description, applicationId: this.editedItem.applicationId,color: this.editedItem.color }

				await axios.post(constants.baseApiUrl + "ActionSecurity/AddNewRole", role)
					.then((res) => this.cancelAddDialog())
					.catch((err) => console.error("Error creating item:", err))
					.finally(()=>{this.fetchData()})
			}
			else {
				var role = { id: this.editedItem.id, name: this.editedItem.name, description: this.editedItem.description, applicationId: this.editedItem.applicationId,color: this.editedItem.color }

				window.showLoading();
				await axios.post(constants.baseApiUrl + "ActionSecurity/UpdateRole?id=" + item.id, role)
					.then((res) => this.cancelAddDialog())
					.catch((err) => console.error("Error Updating item:", err))
					.finally(()=>{
						window.hideLoading(); 
						this.fetchData()
					})
			}
		},
		cancelAddDialog() {
			this.addDialogVisible = false
			this.editedItem.id = null,
				this.editedItem.name = "",
				this.editedItem.description = null,
				this.editedItem.applicationId = null,
				this.getRoles()
		},
		openDeleteDialog(item) {
			window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
				() => {
					axios.get(constants.baseApiUrl + "ActionSecurity/DeleteRole?id=" + item.id)
						.then((res) => this.getRoles())
						.catch((err) => console.log(err));
				},
				() => { })
		},
		closemanageSecurityDialog(){
			this.manageSecurityDialog=false;
			this.Search="";
			this.SearchValue="";
		},
	},
};
</script>
